import { registerPage } from '@zillow/client-profiler-interface-cs';
import { logError } from '@zg-rentals/log-error';
import { MIN_LG } from '@/src/lib/breakpoints';
import { readZgEnvironment } from '@/src/lib/zgEnv';

export type ClientProfilerPageName =
  | 'hotpads-srp'
  | 'hotpads-hdp'
  | 'hotpads-bdp'
  | 'hotpads-homepage'
  | 'hotpads-city-page'
  | 'hotpads-state-page'
  | 'hotpads-my-list';

export function registerClientProfilerPage(pageName: ClientProfilerPageName) {
  if (typeof window === 'undefined') return;

  const platform = window.matchMedia(MIN_LG).matches ? 'desktop' : 'mobile';

  try {
    registerPage({
      pageName,
      // Local dev renders an empty tag; hotpads-web reported 'localhost' there.
      environment: readZgEnvironment() || 'localhost',
      platform,
    });
  } catch (e) {
    logError({
      error: e,
      errorType: 'ClientProfilerRegistrationError',
      context: { pageName },
    });
  }
}
